import React from "react";
import { ConfigProvider, Skeleton } from "antd";

const RedemptionSkeleton: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Skeleton: {
            gradientFromColor: "#404040",
            gradientToColor: "#606060",
          },
        },
      }}
    >
      <div className="bg-[#1E1E1E] p-4 flex flex-col h-[125px] justify-center align-center rounded-lg">
        <Skeleton paragraph={{ rows: 2 }} active />
      </div>
    </ConfigProvider>
  );
};

export default RedemptionSkeleton;
